import { redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';

export const redirectLoggedInToRoot = () => redirectLoggedInTo('/');
export const redirectUnauthorizedToLogIn = () =>
  redirectUnauthorizedTo('login');

export const redirectUnauthorizedToDashboard = () =>
  redirectUnauthorizedTo('dashboard');
